/* eslint-disable max-len */
const i18n = require('react-i18next');
const hoistNonReactStatics = require('hoist-non-react-statics');

const { routes: nextRoutes } = require('../../nextRoutes');

const serverRouter = {
  ...nextRoutes.Router,
  pushRoute: () => {}
};

const originalPushRoutes = nextRoutes.Router.pushRoute;

nextRoutes.Router.pushRoute = (route, options) => {
  originalPushRoutes(route, options);
  window.scrollTo(0, 0);
};

module.exports = {
  Router: typeof window === 'undefined' ? serverRouter : nextRoutes.Router,
  Link: nextRoutes.Link,
  useTranslation: i18n.useTranslation,
  withTranslation: (namespace, options) => Component =>
    hoistNonReactStatics(i18n.withTranslation(namespace, options)(Component), Component),
  nextRoutes,
  Trans: i18n.Trans
};
